export const PROJECT_CONFIG = {
  currency: 'EUR',
  brand_string: 'Propelsia',
  brand_slug: 'propelsia',
  support_email: 'support@propelsia.com',
  noreply_email: 'no-reply@propelsia.app',
  // Domain used to build a per-pro campaign sender address (`{slug}@{domain}`).
  campaign_sender_domain: 'propelsia.io',
  // Domain of the brand's own CRM senders (campaigns and sequences sent by the team). Must be
  // authenticated at Mailjet (SPF, DKIM) and receive mail (all replies go to hello@ on this domain).
  crm_sender_domain: 'propelsia.ai',
  // Root domain of the free pro websites (`{slug}.{domain}`), used in user-facing copy.
  websites_root_domain: 'propelsia.site',
  marketing_signup_url: 'https://propelsia.fr/inscription',
  marketing_site_url: 'https://propelsia.ai',
  help_center_url: 'https://help.propelsia.ai',
  status_page_url: 'https://status.propelsia.ai',
  training_booking_url: 'https://propelsia.io/formation',
  branding: {
    logo_colored: {
      src: '/branding_images/logo-full.svg',
      alt: 'Logo',
      width: 200,
      height: 50,
    },
    logo_white: {
      src: '/branding_images/logo-full-white.svg',
      alt: 'Logo',
      width: 200,
      height: 50,
    },
    // En-tête des e-mails envoyés par la plateforme au pro (pack SEO…) : PNG en URL absolue, les
    // clients mail bloquent le SVG et ne résolvent pas un chemin relatif. Servi par le site vitrine
    // (`packages/website/public/assets/email-signatures/v1/`).
    logo_email: {
      src: 'https://propelsia.ai/assets/email-signatures/v1/propelsia-logo.png',
      alt: 'Logo',
      width: 280,
      height: 68,
    },
    payment_animation: {
      src: '/branding_lottie/animation-payment.json',
    },
    empty_content_cat: {
      src: '/branding_images/empty-box-cat-min.webp',
      alt: 'Empty content',
      width: 300,
      height: 300,
    },
  },
  vat_data: {
    default_vat: 20,
    vat_table: {
      FR: 20,
    },
  },
  default_location: {
    lat: 48.8566,
    lng: 2.3522,
  },
  prices: {
    SMS_100: 900,
    SMS_500: 4000,
    SMS_1000: 7500,
    SMS_5000: 35000,
    EMAIL_100: 300,
    EMAIL_1000: 2500,
    EMAIL_5000: 10000,
    EMAIL_25000: 40000,
  },
};

export type ProjectConfig = typeof PROJECT_CONFIG;
